import { render, staticRenderFns } from "./FacebookButton.vue?vue&type=template&id=44fb43ee&"
import script from "./FacebookButton.vue?vue&type=script&lang=ts&"
export * from "./FacebookButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports